export const policyYearRange = (policyYear) => {
  return `${ policyYear }-${ policyYear + 1}`
}